<template>
  <div class="c-tab-manufacturers">
    <CallCenterADMINmanufacturersTable></CallCenterADMINmanufacturersTable>
  </div>
</template>

<script>
import CallCenterADMINmanufacturersTable from "@/components/Admin/admin-manufacturersTable.vue";
export default {
  name: "c-tab-manufacturers",
  data() {
    return {
      selected: "manufacturers"
    };
  },
  components: {
    CallCenterADMINmanufacturersTable
  }
};
</script>

<style>
.c-tab-manufacturers {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
